import { render, staticRenderFns } from "./ViewImageInterItem.vue?vue&type=template&id=55dfdcdc&"
import script from "./ViewImageInterItem.vue?vue&type=script&lang=js&"
export * from "./ViewImageInterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports